module.exports = __webpack_public_path__ + "static/media/white-play-button-glow.f230f5e1.png";